import { Pipe, PipeTransform } from '@angular/core';
import { ITransmittalMemberModel } from 'src/app/ViewModel/TransmittalTemplateModel';

@Pipe({
  name: 'iGetMemberNamePipe'
})
export class IGetMemberNamePipePipe implements PipeTransform {

  transform(value: ITransmittalMemberModel[]): string {
    if(!!value)
    {
      return value.map(x => x.memberName).join(' / ');
    }
  }

}
